import { createAsyncThunk } from "@reduxjs/toolkit";
import { handlerMap } from "../../../network";
import { EmployeeViewType } from "../../../enums/employeeViewType";
import { phpClient } from "../../../network";
import { DashboardConfigUrl, DashboardConfigWidget, PhpResponse } from "../../../types";
import { getPrimaryActorId } from "../../../utils";
import {
    getDashboardDisplayWidgets,
    getLegacyDashboardCustomLinks,
    normalizeDashboardConfigCustomLinks,
} from "../../../utils/dashboardWidgets";
import type { RootState } from "../../store";


/**
 * @deprecated
 * This function is deprecated and should not be used.
 */
export const fetchPaginatedEmployees = createAsyncThunk(
    "dashboard/fetchPaginatedEmployees",
    async ({ viewType, data }: { viewType: EmployeeViewType; data?: any }, thunkAPI) => {
        const { dispatch, rejectWithValue } = thunkAPI;
        const handler = handlerMap[viewType];

        if (!handler) {
            console.error(`No handler found for viewType: ${viewType}`);
            return rejectWithValue(`Unsupported viewType: ${viewType}`);
        }

        try {
            const resultAction = await dispatch(handler(data)); // Dispatch the thunk

            // Check if the action was fulfilled and return the payload
            if (resultAction.meta.requestStatus === "fulfilled") {
                return { viewType, data: resultAction.payload };
            } else {
                throw resultAction.payload || new Error("Unhandled rejection");
            }
        } catch (error) {
            console.error(`Error fetching data for viewType: ${viewType}`, error);
            return rejectWithValue(error);
        }
    }
);

type DashboardWidgetConfigResponse = {
    widgets?: DashboardConfigWidget[];
    custom_links?: DashboardConfigUrl[];
    urls?: DashboardConfigUrl[];
};

type DashboardWidgetConfigResult = {
    widgets: DashboardConfigWidget[];
    customLinks: DashboardConfigUrl[];
    userId: string | number | null;
};

type DashboardWidgetConfigRejectValue = {
    message: string;
    userId: string | number | null;
};

export const fetchDashboardWidgetConfig = createAsyncThunk<
    DashboardWidgetConfigResult,
    void,
    { state: RootState; rejectValue: DashboardWidgetConfigRejectValue }
>(
    "dashboard/fetchDashboardWidgetConfig",
    async (_, { rejectWithValue, getState }) => {
        const userId = getPrimaryActorId(getState().user.user);

        try {
            const response = await phpClient.get<PhpResponse<DashboardWidgetConfigResponse>>({
                url: "/account/dashboard_config",
            });

            const responseData = response.data || (response as any) || {};
            const rawWidgets = Array.isArray(responseData.widgets) ? responseData.widgets : [];
            const rawCustomLinks = Array.isArray(responseData.custom_links)
                ? responseData.custom_links
                : Array.isArray(responseData.urls)
                    ? responseData.urls
                    : [];
            const widgets = getDashboardDisplayWidgets(rawWidgets);
            const customLinks = normalizeDashboardConfigCustomLinks(
                rawCustomLinks.length > 0 ? rawCustomLinks : getLegacyDashboardCustomLinks(rawWidgets)
            );

            return {
                widgets,
                customLinks,
                userId,
            };
        } catch (error: any) {
            return rejectWithValue({
                message: error.message || "An error occurred",
                userId,
            });
        }
    }
);
